import { render, staticRenderFns } from "./GetQuote.vue?vue&type=template&id=29c40f66&scoped=true&"
import script from "./GetQuote.vue?vue&type=script&lang=ts&"
export * from "./GetQuote.vue?vue&type=script&lang=ts&"
import style0 from "./GetQuote.vue?vue&type=style&index=0&id=29c40f66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c40f66",
  null
  
)

export default component.exports